import { useLocation } from 'react-router-dom'
import { Sun, Moon } from '@phosphor-icons/react'
import { useUIStore } from '@/stores/uiStore'
import { SidebarTrigger } from '@/components/ui/sidebar'
import { Separator } from '@/components/ui/separator'
import { Button } from '@/components/ui/button'

const pageTitles: Record<string, string> = {
  '/': 'Dashboard',
  '/organizations': 'Organizations',
  '/organizations/new': 'Create Organization',
  '/usage': 'Usage & Costs',
  '/audit': 'Audit Log',
}

export function TopBar() {
  const location = useLocation()
  const { theme, toggleTheme } = useUIStore()

  // Resolve page title: exact match first, then check for dynamic nested routes
  let pageTitle = pageTitles[location.pathname]
  if (!pageTitle && location.pathname.startsWith('/organizations/')) {
    if (/\/organizations\/[^/]+\/users\/[^/]+/.test(location.pathname)) {
      pageTitle = 'User Detail'
    } else {
      pageTitle = 'Organization'
    }
  }
  pageTitle = pageTitle ?? 'Dashboard'

  return (
    <header className="flex h-14 shrink-0 items-center gap-2 border-b border-border bg-background px-4">
      <SidebarTrigger className="-ml-1" />
      <Separator orientation="vertical" className="mr-2 h-4" />
      <h1 className="text-sm font-medium text-foreground">{pageTitle}</h1>

      <div className="ml-auto flex items-center gap-2">
        <Button
          variant="ghost"
          size="icon"
          onClick={toggleTheme}
          className="h-8 w-8"
          aria-label={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
        >
          {theme === 'light' ? (
            <Moon className="h-4 w-4" />
          ) : (
            <Sun className="h-4 w-4" />
          )}
        </Button>
      </div>
    </header>
  )
}
